var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    transform: "translate(-2121 7448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    transform: "translate(1778 -7787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4570",
    "data-name": "Path 4570",
    d: "M367,340v4a1,1,0,0,1-1,1H354a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h12A1,1,0,0,1,367,340Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4571",
    "data-name": "Path 4571",
    d: "M351,343h-5a3,3,0,0,0-3,3v32a3,3,0,0,0,3,3h28a3,3,0,0,0,3-3V346a3,3,0,0,0-3-3h-5v1a3,3,0,0,1-3,3H354a3,3,0,0,1-3-3Zm-3.707,29.707,2,2a1,1,0,0,0,1.414,0l4-4a1,1,0,0,0-1.414-1.414L350,372.586l-1.293-1.293a1,1,0,0,0-1.414,1.414ZM358,373h14a1,1,0,0,0,0-2H358a1,1,0,0,0,0,2Zm-10.707-8.293,2,2a1,1,0,0,0,1.414,0l4-4a1,1,0,0,0-1.414-1.414L350,364.586l-1.293-1.293a1,1,0,0,0-1.414,1.414ZM358,365h14a1,1,0,0,0,0-2H358a1,1,0,0,0,0,2Zm-10.707-8.293,2,2a1,1,0,0,0,1.414,0l4-4a1,1,0,0,0-1.414-1.414L350,356.586l-1.293-1.293a1,1,0,0,0-1.414,1.414ZM358,357h14a1,1,0,0,0,0-2H358a1,1,0,0,0,0,2Z",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.6ad6ef056556549f11f766f3b129f6ce.svg";
export { ForwardRef as ReactComponent };